module.exports = __webpack_public_path__ + "static/media/likes.75e5323d.svg";